import { CommandData } from "../../command/command";
import { GxmlCommand } from "./gxml-command";
export class SetPropertyValueCommand extends GxmlCommand {
    constructor(node, name, oldValue, value) {
        super();
        this._node = node;
        this._name = name;
        this._oldValue = oldValue;
        this._value = value;
    }
    get id() {
        return SetPropertyValueCommandData.ID;
    }
    get changeRoot() {
        return this._node;
    }
    do() {
        this._node.setPropertyValue(this._name, this._value);
        return true;
    }
    undo() {
        this._node.setPropertyValue(this._name, this._oldValue);
        return true;
    }
    getData() {
        return {
            id: this.id,
            nodeId: this._node.id,
            name: this._name,
            oldValue: this._oldValue,
            value: this._value
        };
    }
}
export var SetPropertyValueCommandData;
(function (SetPropertyValueCommandData) {
    SetPropertyValueCommandData.ID = 'SetPropertyValue';
    function is(arg) {
        return CommandData.is(arg)
            && arg.id === SetPropertyValueCommandData.ID
            && 'nodeId' in arg
            && 'oldValue' in arg
            && 'value' in arg;
    }
    SetPropertyValueCommandData.is = is;
})(SetPropertyValueCommandData || (SetPropertyValueCommandData = {}));
//# sourceMappingURL=set-property-value-command.js.map